module.exports = __webpack_public_path__ + "static/aarakocra-2053b2cd764598700b7c624111c4b83f.jpg";